import { safeReturnDestination } from './mail-links';
export const navigateBasedOnRoleAndVerification = (role, isShuftiProVerified, navigate, returnTo) => {
    const destination = safeReturnDestination(returnTo, role);
    if (['Admin', 'SuperAdmin'].includes(role)) {
        navigate(destination || '/');
    }
    else if (role === 'Freelancer') {
        if (isShuftiProVerified) {
            navigate(destination || '/dashboard');
        }
        else {
            navigate('/my-profile-account-information');
        }
    }
};
